var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<h3>");t.b(t.v(t.f("name",c,p,0)));t.b("</h3>");t.b("\n" + i);t.b(t.v(t.f("description",c,p,0)));t.b("\n" + i);t.b("<hr>");return t.fl(); },partials: {}, subs: {  }}, "<h3>{{name}}</h3>\n{{description}}\n<hr>", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/vod-partial.mustache
// module id = 879
// module chunks = 2